/* eslint-disable react/no-array-index-key */
/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useCallback, useContext, useEffect, useState } from 'react'

import {
  EditTwoTone,
  ClockCircleTwoTone,
  StopTwoTone,
  CloseOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  PageHeader,
  Radio,
  Result,
  Row,
  Select,
  Slider,
  Table,
  TimePicker,
  Tooltip,
  Typography,
} from 'antd'
import ID_COMPONENTE from 'config/idComponente'
import Claims from 'Hooks/usePermissions/Claims'
import usePermissions from 'Hooks/usePermissions/usePermissions'
import moment from 'moment'
import { Scrollbars } from 'react-custom-scrollbars'
import WsDocasService from 'Services/WS_DOCAS'

import { IArmazem } from '../../../Models/docas'
import BloqueioAgenda from '../Armazem/BloqueioAgenda'
import CadastroEdicaoArmazem from '../Armazem/CadastroEdicaoArmazem'
import LiberacaoAgenda from '../Armazem/LiberacaoAgenda'

const ModalConfigurarArmazem = () => {
  const [armazemItens, setArmazemItens] = useState<IArmazem[]>()

  const [armazemSelecionado, setArmazemSelecionado] = useState<IArmazem>()

  const [tela, setTela] = useState<string>('')

  const [dataSelecionada, setDataSelecionada] = useState<moment.Moment>(
    moment(),
  )
  const [janelasSecundarias, setJanelasSecundarias] = useState(0)

  const [result, setResult] = useState<number>(0)
  const [resultError, setResultError] = useState<string>('')
  const { isAuthorized } = usePermissions()

  const disabledDates = (current: moment.Moment) => {
    const inPast = moment().diff(current, 'days') > 0
    const tooEarly = current.diff(moment().add(10, 'days'), 'days') >= 0
    return inPast || tooEarly
  }

  const getArmazens = async () => {
    const { data } = await WsDocasService.armazem.getList(ID_COMPONENTE.DOCAS, {
      apenasAtivos: false,
    })
    if (data.items) {
      setArmazemItens(data.items)
    }
  }

  const getArmazensDetalhes = async (armazemSelecionado: number) => {
    const { data } = await WsDocasService.armazem.details(
      ID_COMPONENTE.DOCAS,
      armazemSelecionado,
      moment().format('YYYY-MM-DD HH:mm:ss'),
    )
    if (data && data.items) {
      setArmazemSelecionado(data.items)
      setTela('bloquearAgenda')
    }
  }

  useEffect(() => {
    getArmazens()
    return () => {
      setResult(0)
      setResultError('')
    }
  }, [])

  const preparaConfiguracao = async (tela: string, cdArmazem?: number) => {
    let sucesso = true

    if (cdArmazem) {
      const { data } = await WsDocasService.armazem.details(
        ID_COMPONENTE.DOCAS,
        cdArmazem,
        moment().format('YYYY-MM-DD'),
      )

      if (data.items) {
        setArmazemSelecionado(data.items)
      } else {
        sucesso = false
      }
    }

    if (sucesso) {
      setTela(tela)
      setResult(0)
      setResultError('')
    } else {
      setResultError(
        'Ocorreu um erro ao buscar os detalhes do armazem, atualize a tela e tente novamente',
      )
    }
  }

  return (
    <Col flex="100%">
      <Row>
        <Col span={12}>
          {isAuthorized(Claims.CriarEditarArmazem) && (
            <Tooltip title="Adicionar armazém">
              <Button onClick={() => preparaConfiguracao('adicionarArmazem')}>
                <PlusOutlined /> Adicionar armazém
              </Button>
            </Tooltip>
          )}
          <Scrollbars style={{ marginTop: '15px', height: '450px' }}>
            <Table
              size="small"
              pagination={false}
              loading={!armazemItens}
              columns={[
                {
                  title: 'Nome',
                  dataIndex: 'nomeArmazem',
                },
                {
                  title: 'Situação',
                  dataIndex: 'ativo',
                  width: 80,
                  render: (ativo: boolean) => (ativo ? 'Ativo' : 'Inativo'),
                },
                {
                  title: 'Ações',
                  dataIndex: 'cdAgendamentoDocasArmazem',
                  width: 180,
                  render: (cdArmazem: number) => (
                    <>
                      {isAuthorized(Claims.CriarEditarArmazem) && (
                        <Tooltip title="Editar armazém">
                          <Button
                            style={{ width: '50px' }}
                            onClick={() =>
                              preparaConfiguracao('editarArmazem', cdArmazem)
                            }
                          >
                            <EditTwoTone />
                          </Button>
                        </Tooltip>
                      )}
                      <Tooltip title="Liberar agenda">
                        <Button
                          style={{ width: '50px' }}
                          onClick={() =>
                            preparaConfiguracao('liberarAgenda', cdArmazem)
                          }
                        >
                          <ClockCircleTwoTone />
                        </Button>
                      </Tooltip>
                      <Tooltip title="Bloquear agenda">
                        <Button
                          style={{ width: '50px' }}
                          onClick={() =>
                            preparaConfiguracao('bloquearArmazem', cdArmazem)
                          }
                        >
                          <StopTwoTone />
                        </Button>
                      </Tooltip>
                    </>
                  ),
                },
              ]}
              dataSource={armazemItens}
            />
          </Scrollbars>
        </Col>

        <Col offset={1} span={11}>
          {tela === 'adicionarArmazem' && (
            <CadastroEdicaoArmazem
              setTela={setTela}
              getArmazens={getArmazens}
            />
          )}

          {tela === 'editarArmazem' && (
            <CadastroEdicaoArmazem
              setTela={setTela}
              armazemSelecionado={armazemSelecionado}
              getArmazens={getArmazens}
            />
          )}

          {tela === 'liberarAgenda' && (
            <LiberacaoAgenda
              armazemSelecionado={armazemSelecionado}
              dataSelecionada={dataSelecionada}
              setDataSelecionada={setDataSelecionada}
              setTela={setTela}
            />
          )}

          {tela === 'bloquearAgenda' && (
            <BloqueioAgenda
              armazemSelecionado={armazemSelecionado}
              dataSelecionada={dataSelecionada}
              setTela={setTela}
            />
          )}
        </Col>
      </Row>
    </Col>
  )
}

export default ModalConfigurarArmazem
